import { abcPurchaseReport } from "./abc-purchase-report";
import { abcSupplierReport } from "./abc-supplier-report";

export const abcReports = {
	abcPurchaseReport,
	abcSupplierReport,
	header: {
		filter: {
			period: "Período",
			curves: {
				label: "Filtrar por",
				placeholder: "Todas las curvas",
			},
		},
		searchPlaceholderProducts: "Buscar por producto o insumo",
		searchPlaceholderSuppliers: "Buscar por proveedor",
	},
};
